import { client } from './api-client';

// User profile information
export const fetchGetProfile = () => client.get(`me`);
export const fetchUpdateProfile = (body) => client.patch(`me`, body);
export const fetchUploadAvatar = (body) => client.post(`avatar`, body);
export const userChangePassword = (body) => client.post('me', body);

// User push notifications
export const fetchUserPushes = (page) => client.get(`push-notifications/my?page=${page || 1}`);
export const markPushAsRead = (body) => client.post('push-notifications/batch-read', body);
export const subscribeDevice = (body) => client.post('push-notifications/register', body);

// User video list collections (available for authorized user)
export const mggFetchUserRecommendedVideos = (limit) =>
  client.get(`mgg/user/recommended?limit=${limit}`);
export const mggFetchPurchasedVideos = (limit) => client.get(`mgg/user/tvod?limit=${limit}`);
export const fetchGetFaq = () => client.get('faq');
export const fetchGetNews = (page) => client.get(`news${page ? `?page=${page}` : ''}`);
export const fetchGetArticle = (slug, token) =>
  client.get(`news/${slug}${token ? `?token=${token}` : ''}`);
export const fetchGetFaqBySlug = (slug) => client.get(`faq/${slug}`);
export const fetchGetDocuments = () => client.get('documents');
